module.exports = __webpack_public_path__ + "static/media/48.0b0b624a.jpg";